export const onEnter = (event, callback) => {
  if (event.key === 'Enter' && callback) {
    callback(event)
  }
}
